export const ACTION_REGO_SEARCH = 'actionRegoSearch'
export const ACTION_REGO_REMOVE = 'actionRegoRemove'
export const ACTION_REGO_SEARCHED = 'actionRegoSearched'
export const ACTION_RESET_REGO_SEARCHED = 'actionResetRegoSearched'
export const ACTION_REGO_LOOKUP_COMPLETED = 'actionAGRegoLookupCompleted'
export const ACTION_RESET_REGO_LOOKUP_COMPLETED = 'actionResetAGRegoLookupCompleted'
